import React from 'react';

import cl from 'classnames';

import { renderLogoImage } from 'detailsv2/PDFPreviewV2/Pages/TemplatePage/Header/functions';

import Logo from '../../shared/Logo';
import { renderLeftContentDefault, renderRightContentDefault } from './functions';
import s from './index.module.css';

function Header({
  brandLogo,
  brandCompanyName,
  companyLogo,
  companyName,
  whiteLabelingOn,
  whiteLabelingDisplayCompanyLogo,
  border = true,
  renderLeftContent = renderLeftContentDefault,
  renderRightContent = renderRightContentDefault,
  ...rest
}) {
  const renderBrandLogo = () => {
    if (!whiteLabelingOn) return null;
    return <Logo logo={brandLogo} companyName={brandCompanyName} renderImage={renderLogoImage} />;
  };

  const renderCompanyLogo = () => {
    if (whiteLabelingOn) {
      if (!whiteLabelingDisplayCompanyLogo) return null;
    }
    return <Logo logo={companyLogo} companyName={companyName} renderImage={renderLogoImage} />;
  };

  return (
    <div className={cl({ [s.border]: border }, s.container)}>
      <div className={cl(s.flexItem, s.flexItemLeft)}>{renderLeftContent(rest)}</div>

      <div className={cl(s.flexItem, s.flexItemCenter)}>
        {renderBrandLogo()}

        {renderCompanyLogo()}
      </div>

      <div className={cl(s.flexItem, s.flexItemRight)}>
        {renderRightContent({ ...rest, companyName: brandCompanyName })}
      </div>
    </div>
  );
}

export default Header;
